import {Referral} from 'placement/domains';
import React from 'react';

import {PlacementType, ServiceType} from "../const";

type Props = {
    referral: Referral;
}

const isPsychotherapyService = (referral: Referral) =>
    referral.serviceTypes.includes(ServiceType.Compass_Psychotherapy) || referral.serviceTypes.includes(ServiceType.Psychotherapy)


export function EstimatedServiceHoursSection({referral}: Props) {
    const showHours = referral?.placementType === PlacementType.TreatmentOnly || referral?.placementType === PlacementType.AssessmentWithConcurrentTreatment;
    if (!showHours) {
        return <></>;
    }

    return (
        <div className="pb-5">
            <div className='font-semibold pb-5'>
                Clinical Recommendation
            </div>
            {isPsychotherapyService(referral) ?
                psychotherapyHoursRender(referral) : defaultTreatmentHoursRender(referral)}
        </div>
    );
}

const psychotherapyHoursRender = (referral: Referral) => {
    if ((referral.authTherapyTreatmentUnitsPer == null || referral.authTherapyTreatmentUnitsPer === "") ||
        (referral.authTherapyTreatmentUnitType == null || referral.authTherapyTreatmentUnitType === "") ||
        referral.authTherapyTreatmentUnit == null) {
        return <div>None</div>
    }
    return <div>
        {`${referral.authTherapyTreatmentUnit} ${referral.authTherapyTreatmentUnitType} per ${referral.authTherapyTreatmentUnitsPer}`}
    </div>

}

const defaultTreatmentHoursRender = (referral: Referral) => {
    const hasGroup = referral.serviceTypes.some((el) => [ServiceType.GroupABA, ServiceType.SocialSkillsGroup].includes(el as ServiceType));
    return (
        <>
            <div className='flex pb-2'>
                <div className='italic'>
                    Caregiver Mediated Treatment
                </div>
            </div>
            <div className='flex pb-2'>
                <div className='w-1/2'>
                    Mid Level
                </div>
                <div className='w-1/2'>
                    {referral.careMediatedMidMinHours == null? '' : referral.careMediatedMidMinHours} - {referral.careMediatedMidHours == null? '' : referral.careMediatedMidHours} hours per month
                </div>
            </div>
            <div className='flex pb-2'>
                <div className='w-1/2'>
                    High Level
                </div>
                <div className='w-1/2'>
                    {referral.careMediatedHighMinHours == null? '' : referral.careMediatedHighMinHours} - {referral.careMediatedHighHours == null? '' : referral.careMediatedHighHours} hours per month
                </div>
            </div>

            <div className='flex pb-2 mt-2'>
                <div className='italic'>
                    Practitioner Mediated Treatment
                </div>
            </div>
            <div className='flex pb-2'>
                <div className='w-1/2'>
                    Direct Care
                </div>
                <div className='w-1/2'>
                    {referral.practDirectBeneficialHours == null ? '' : referral.practDirectBeneficialHours} - {referral.practDirectOptimalHours == null ? '' : referral.practDirectOptimalHours} hours
                    per month
                </div>
            </div>
            <div className='flex pb-2'>
                <div className='w-1/2'>
                    Mid Level
                </div>
                <div className='w-1/2'>
                    {referral.practMidBeneficialHours == null ? '' : referral.practMidBeneficialHours} - {referral.practMidOptimalHours == null ? '' : referral.practMidOptimalHours} hours
                    per month
                </div>
            </div>
            <div className='flex pb-2'>
                <div className='w-1/2'>
                    High Level
                </div>
                <div className='w-1/2'>
                    {referral.practHighBeneficialHours == null ? '' : referral.practHighBeneficialHours} - {referral.practHighOptimalHours == null ? '' : referral.practHighOptimalHours} hours
                    per month
                </div>
            </div>
            {hasGroup &&
                <div className='flex pb-2'>
                    <div className='w-1/2'>
                        Group Care
                    </div>
                    <div className='w-1/2'>
                        {referral.practGroupBeneficialHours == null ? '' : referral.practGroupBeneficialHours} - {referral.practGroupOptimalHours == null ? '' : referral.practGroupOptimalHours} hours
                        per month
                    </div>
                </div>
            }
        </>)
}
